import { Instance } from 'mobx-state-tree';
import { BillingPlanCancellationRevokedDtoModelBase } from './BillingPlanCancellationRevokedDtoModel.base';

/* The TypeScript type of an instance of BillingPlanCancellationRevokedDtoModel */
export interface BillingPlanCancellationRevokedDtoModelType extends Instance<typeof BillingPlanCancellationRevokedDtoModel.Type> {}

/* A graphql query fragment builders for BillingPlanCancellationRevokedDtoModel */
export { selectFromBillingPlanCancellationRevokedDto, billingPlanCancellationRevokedDtoModelPrimitives, BillingPlanCancellationRevokedDtoModelSelector } from './BillingPlanCancellationRevokedDtoModel.base';

/**
 * BillingPlanCancellationRevokedDtoModel
 */
export const BillingPlanCancellationRevokedDtoModel = BillingPlanCancellationRevokedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
